import { COIN_TICKER } from '../../../pages/auth/models/Crypto';
import { Pipe, PipeTransform } from '@angular/core';
import { CryptoService } from '../../../pages/auth/abstraction/crypto.service';

@Pipe({
  name: 'formatCoinAmount',
})
export class FormatCoinAmountPipe implements PipeTransform {
  constructor(private cryptoService: CryptoService) {}

  transform(value: number | string, args: string): string {
    let min = 2;
    let max;
    if (
      args === 'AR$' ||
      args === 'ARS' ||
      args === 'CLP' ||
      args === 'COP' ||
      args === 'GTQ' ||
      args === 'BRL' ||
      args === 'CRC' ||
      args === 'PUSD' ||
      args === 'MXN'
    ) {
      min = 2;
      max = 2;
    } else if (
      args === 'U$D' ||
      args === 'USD' ||
      args === 'STABLES' ||
      args === '$TABLES' ||
      this.cryptoService.isStableCoin(args) ||
      args === 'NUARS'
    ) {
      min = 2;
      max = 3;
    } else {
      min = 5;
      max = 5;
    }
    const multiplier = Math.pow(10, max);
    const truncatedValue = Math.floor(+value * multiplier) / multiplier;
    const priceFormat = new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: min,
      maximumFractionDigits: max,
    });
    return priceFormat.format(Number(truncatedValue));
  }
}
